<div class="w-full">
  <app-stepper (selectedIndexChange)="changeStep($event)" [linear]="true" [nextStepAllowed]="nextStepAllowed"
               [previousStepAllowed]="previousStepAllowed" [selectedIndex]="selectedStep"
               [stepTooltips]="stepTooltips"
               class="flex flex-row h-full w-full">
    @if (isCheckView) {
      <cdk-step [label]="'Prüfregelauswahl'">
      </cdk-step>
      <cdk-step [label]="'Dateiauswahl'">
      </cdk-step>
      <cdk-step [label]="'Prüfergebnisse'">
      </cdk-step>
    } @else {
      <cdk-step [label]="'Konformitäts-Check'" [completed]="true" [editable]="!isStepDisabled(0)">
      </cdk-step>
      <cdk-step [completed]="selectedStep != 1" [label]="'All-Right Check'">
      </cdk-step>
    }
  </app-stepper>

</div>
